import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'

import './style.scss'
import HeaderPages from '../../sections/header/HeaderPages'

function Page404() {
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<HeaderPages />
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='text-404'>404</div>
					<div className='sub-text'>Page not found! please check the URL and try again or return to the home page</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default Page404
